import { computed, defineComponent, onMounted, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { BudgetTypeAction, BudgetTypeGetter } from '@/store/budgetType/budgetType.module';
import { BudgetType } from '@/store/budgetType/budgetType.model';
import { ProjectResultGetter } from '@/store/projectResult/projectResult.module';
import { ProjectRegionResult, ProjectRegionResultItem } from '@/store/projectResult/projectResult.model';
import { BudgetForm } from '@/store/project/project.model';

export default defineComponent({
  name: 'BudgetFormComponent',
  props: {
    budgets: {
      type: Object as PropType<BudgetForm[]>,
      required: true,
    }
  },
  emits: [
    'validated'
  ],
  setup: (props, context) => {
    const store = useStore();
    const toast = useToast();
    const result = computed<ProjectRegionResult>(() => store.getters[ProjectResultGetter.REGION_RESULT]);
    const provinces = computed<ProjectRegionResultItem[]>(() => result.value?.provinces);
    const balance = computed(() => result.value?.regionResidual - provinces.value?.reduce((total, m) => total + m.totalResidual, 0));
    const budgetTypes = computed<BudgetType[]>(() => {
      const bTypes = store.getters[BudgetTypeGetter.ALL] as BudgetType[];
      return bTypes.filter(m => m.id !== 1 && budgetForm.value?.map(x => x.budgetTypeId).includes(m.id) === false);
    });
    const budgetForm = ref<BudgetForm[]>(props.budgets.map(m => {
      return {
        budgetTypeId: m.budgetTypeId,
        budgetTypeName: m.budgetTypeName,
        amount: m.amount
      };
    }));

    onMounted(() => {
      store.dispatch(BudgetTypeAction.FETCH);
    });

    watch(() => props.budgets, (budgets) => {
      budgetForm.value = budgets.map(m => {
        return {
          budgetTypeId: m.budgetTypeId,
          budgetTypeName: m.budgetTypeName,
          amount: m.amount
        };
      });
    });

    const addBudget = (budgetTypeId: number, shortName: string) => {
      budgetForm.value.push({
        budgetTypeId: budgetTypeId,
        budgetTypeName: shortName,
      });
    };

    const removeBudget = (budgetTypeId: number) => {
      const index = budgetForm.value.findIndex(m => m.budgetTypeId === budgetTypeId);
      budgetForm.value.splice(index, 1);
    };

    // submit form
    const submitForm = () => {
      if (budgetForm.value.length > 0 && budgetForm.value.every(m => m.amount && m.amount > 0 && m.amount <= balance.value)) {
        context.emit('validated', budgetForm.value);
      } else {
        toast.error(budgetForm.value.length > 0 ? 'ข้อมูลการจัดสรรงบประมาณไม่ถูกต้อง' : 'กรุณาป้อนข้อมูลการจัดสรรงบประมาณ');
      }
    };

    const clearForm = () => {
      budgetForm.value = props.budgets.map(m => {
        return {
          budgetTypeId: m.budgetTypeId,
          budgetTypeName: m.budgetTypeName,
          amount: m.amount };
      });
    };

    return {
      budgetForm,
      budgetTypes,
      addBudget,
      removeBudget,
      submitForm,
      clearForm,
    };
  },
});
